/*
 * Cantidad que aplica al color de la aplicación para aclararlo
 */
const LIGHT_AMOUNT = 30;

/*
 * Cantidad que aplica al color de la aplicación para oscurecerlo
 */
const DARK_AMOUNT = -20;

export { LIGHT_AMOUNT, DARK_AMOUNT };
